import React from "react";
import "./popups.scss";

import QuerxSVG from "../../../../assets/qsvg1.svg";
import { withTranslation } from 'react-i18next';

class QuerxPrompt extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { ready: false };
  }

  componentDidMount() {
    window.setTimeout(() => {
      this.setState({ ready: true });
    }, 100);
  }
  render() {
    let { 
      //onHide, 
      detectedQuerx, 
      //requestActivateTemplate, 
      t } = this.props;
    let querxType = detectedQuerx.qname || "";

    let popupCssClass = "popup";
    popupCssClass += this.state.ready ? " ready" : "";
    return (
      <div className={popupCssClass}>
        <div className="popup-inner querxpromt">
          <h1>
            Querx {querxType}
            <br /> {t('detected_word')}!
          </h1>
          <img src={QuerxSVG} alt=""/>
          <h3 style={{maxWidth: 300}}>
            {t('template_prompt')}
          </h3>
        </div>
        <div className="popup-controls">
          <div className="modal-button" onClick={this.onActivate.bind(this)}>
            {t('yes_word')}
          </div>
          <div
            className="modal-button negative"
            onClick={this.onDeny.bind(this)}
          >
            {t('no_word')}
          </div>
        </div>
      </div>
    );
  }

  onActivate() {
    let { onHide, detectedQuerx, requestActivateTemplate } = this.props;
    let { device_id, template_val } = detectedQuerx;
    requestActivateTemplate(device_id, template_val);
    onHide();
  }

  onDeny() {
    let {
      detectedQuerx,
      onHide,
      addToDeviceTemplateBlacklist,
      //removeFromDeviceTemplateBlacklist
    } = this.props;
    let { device_id, template_val } = detectedQuerx;
    // Add template id to blacklist array, send to server.
    addToDeviceTemplateBlacklist(device_id, template_val);
    onHide();
  }
}

export default withTranslation()(QuerxPrompt);
